<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ChooseGoods')"
    width="960px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="grid-view">
      <div class="main-content">
        <div style="display: flex; margin-bottom: 10px;">
          <span style="margin-right: 10px;">{{ $t('SeaExport.ContainerSize') }}：</span> {{ containerInfo.eqSize + containerInfo.eqType }}
          <span style="margin-left: 10px;margin-right: 10px;">{{ $t('SeaExport.ContainerNo') }}：</span> {{ containerInfo.containerNo }}
          <span style="margin-left: 10px;margin-right: 10px;">{{ $t('SeaExport.SealNo') }}：</span> {{ containerInfo.sealNo }}
        </div>
        <div class="app-main-inner-row">
          <el-form v-show="goodsMode === SystemConstants.FCL_TYPE.code || goodsMode === SystemConstants.CONSOLE_TYPE.code" label-width="80px" label-position="left">
            <el-row :gutter="10">
              <el-col :span="7">
                <el-form-item :label="$t('SeaExport.Supplier')">
                  <el-input v-model="form.suppliesr" />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('SeaExport.OrderNo2')">
                  <el-input v-model="form.poNo" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label-width="0">
                  <el-button type="primary" no="1" @click="searchHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                  <el-button type="primary" no="2" @click="chooseHandler">{{ $t('SeaExport.confirmImport') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form v-show="goodsMode === SystemConstants.LCL_TYPE.code" label-width="80px" label-position="left">
            <el-row :gutter="10">
              <el-col :span="7">
                <el-form-item :label="$t('SeaExport.Supplier')">
                  <el-input v-model="form.suppliesr" />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('SeaExport.Anufacturer')">
                  <el-input v-model="form.anufacturer" />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="$t('SeaExport.Source')">
                  <el-input v-model="form.source" />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label-width="0">
                  <el-button type="primary" no="1" @click="searchHandler">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="7">
                <el-form-item :label="$t('SeaExport.OrderNo2')">
                  <el-input v-model="form.poNo" />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="'SKU '+$t('SeaExport.NO')">
                  <el-input v-model="form.itemNo" />
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item :label="'HBL'+$t('SeaExport.NO')">
                  <el-input v-model="form.hblNo" />
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label-width="0">
                  <el-button type="primary" no="2" @click="chooseLclHandler">{{ $t('SeaExport.confirmImport') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
          <cargo-ag-grid
            v-show="goodsMode === SystemConstants.FCL_TYPE.code"
            config-module="130149"
            :grid-options="fcl.gridOptions"
            :column-defs="fcl.columnDefs"
            :row-data="fcl.rowData"
            :deselect-sub-record="true"
            style="width:100%;height: 400px;"
            @gridReady="onFclGridReady"
          />
          <cargo-ag-grid
            v-show="goodsMode === SystemConstants.LCL_TYPE.code"
            config-module="130132"
            :grid-options="lcl.gridOptions"
            :column-defs="lcl.columnDefs"
            :row-data="lcl.rowData"
            :deselect-sub-record="true"
            style="width:100%;height: 400px;"
            @gridReady="onLclGridReady"
          />
          <cargo-ag-grid
            v-show="goodsMode === SystemConstants.CONSOLE_TYPE.code"
            config-module="130152"
            :grid-options="console.gridOptions"
            :column-defs="console.columnDefs"
            :row-data="console.rowData"
            :deselect-sub-record="true"
            style="width:100%;height: 400px;"
            @gridReady="onConsoleGridReady"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {
  queryPoPackageListWithHblNo,
  batchAddEdiContainerPackage,
  queryOrderListByContainer,
  batchModifyEdiContainerPoInfo,
  queryOrderListByConsoleContainer
} from '@/api/seaExport/container'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TradeDetailSelectOrderWindow',
  props: {
    visible: { type: Boolean, required: true },
    goodsMode: { type: String, required: true, default: () => 'FCL' },
    containerInfo: { type: Object, required: true, default: () => {} },
    cargoDoc: { type: Object, required: true, default: () => {} }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      SystemConstants,
      fcl: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true
        },
        gridApi: {},
        rowData: [],
        columnDefs: [
          {
            headerName: '', width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true,
            checkboxSelection: (item) => {
              const { data } = item
              if (!data.poNo) {
                return false
              }
              return true
            }
          },
          { headerName: this.$t('SeaExport.OrderNo2'), field: 'poNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerSize'), field: 'eqSize', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerRule'), field: 'eqType', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 100 },
          { headerName: this.$t('SeaExport.ContainerNo'), field: 'containerNo', width: 150 },
          {
            headerName: this.$t('SeaExport.Supplier'),
            field: 'supplierId',
            colId: 'supplierId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Source'), field: 'source', width: 150 },
          { headerName: 'HBL' + this.$t('SeaExport.NO'), field: 'hblNo', width: 150 }
        ]
      },
      lcl: {
        gridOptions: {
          rowSelection: 'multiple'
        },
        gridApi: {},
        rowData: [],
        columnDefs: [
          {
            headerName: '', width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true,
            checkboxSelection: (item) => {
              const { data } = item
              if (!data.packageNo) {
                return false
              }
              return true
            }
          },
          { headerName: this.$t('SeaExport.PackageNo'), field: 'packageNo', colId: 'packageNo', width: 150 },
          { headerName: this.$t('SeaExport.OrderNo2'), field: 'poNo', width: 150 },
          { headerName: 'SKU ' + this.$t('SeaExport.Code3'), field: 'itemNo', width: 150 },
          { headerName: 'SKU ' + this.$t('SeaExport.Quantity2'), field: 'skuNum', width: 150 },
          { headerName: this.$t('SeaExport.NumberOfCartons'), field: 'cartonNum', width: 150 },
          { headerName: this.$t('SeaExport.PackageType'), field: 'packageType', width: 150 },
          { headerName: this.$t('SeaExport.NumberOfPackages'), field: 'numberOfPackages', width: 150,
            cellRenderer: (item) => {
              const { data } = item
              return `<span style="color:blue">${data.estimatedNumberOfPackages}</span> /
                       <span style="color:blue">${data.numberOfPackages}</span>`
            } },
          { headerName: this.$t('SeaExport.Weight') + '(KGS)', field: 'weight', width: 150,
            cellRenderer: (item) => {
              const { data } = item
              const estimatedWeight = ColumnUtils.number3ColumnLabelFunc(data.estimatedWeight)
              const weight = ColumnUtils.number3ColumnLabelFunc(data.weight)
              return `<span style="color:blue">${estimatedWeight}</span> /
                       <span style="color:blue">${weight}</span>`
            } },
          { headerName: this.$t('SeaExport.Cubage') + '(CBM)', field: 'cubage', width: 150,
            cellRenderer: (item) => {
              const { data } = item
              const estimatedCubage = ColumnUtils.number3ColumnLabelFunc(data.estimatedCubage)
              const cubage = ColumnUtils.number3ColumnLabelFunc(data.cubage)
              return `<span style="color:blue">${estimatedCubage}</span> /
                       <span style="color:blue">${cubage}</span>`
            } },
          {
            headerName: this.$t('SeaExport.Supplier'),
            field: 'supplierId',
            colId: 'supplierId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Source'), field: 'source', width: 150 },
          {
            headerName: this.$t('SeaExport.Anufacturer'),
            field: 'producerId',
            colId: 'producerId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: 'HBL' + this.$t('SeaExport.NO'), field: 'hblNo', width: 150 }
        ]
      },
      console: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true
        },
        gridApi: {},
        rowData: [],
        columnDefs: [
          {
            headerName: '', width: 55, sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true,
            checkboxSelection: (item) => {
              const { data } = item
              if (!data.poNo) {
                return false
              }
              return true
            }
          },
          { headerName: this.$t('SeaExport.OrderNo2'), field: 'poNo', width: 150 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerSize'), field: 'eqSize', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_ContainerRule'), field: 'eqType', width: 100 },
          { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 100 },
          { headerName: this.$t('SeaExport.ContainerNo'), field: 'containerNo', width: 150 },
          {
            headerName: this.$t('SeaExport.Supplier'),
            field: 'supplierId',
            colId: 'supplierId',
            width: 150,
            valueFormatter(params) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('SeaExport.Source'), field: 'source', width: 150 },
          { headerName: 'HBL' + this.$t('SeaExport.NO'), field: 'hblNo', width: 150 }
        ]
      },
      totalDesc: { // 合计汇总
        estimatedTotalPackings: 0,
        totalPackings: 0,
        estimatedTotalCubages: 0,
        totalCubages: 0,
        estimatedTotalWeight: 0,
        totalWeight: 0
      },
      totalLabel: { // 合计汇总label
        TotalPacking: this.$t('SeaExport.TotalPacking') + ':',
        TotalCubage: this.$t('SeaExport.TotalCubage') + ' CBM:',
        TotalWeight2: this.$t('SeaExport.TotalWeight2') + 'KGS:'
      },
      form: {
        suppliesr: '',
        anufacturer: '',
        source: '',
        poNo: '',
        itemNo: '',
        hblNo: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery(null)
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.fcl.rowData = []
        this.lcl.rowData = []
        this.console.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery(null)
    }
  },
  methods: {
    searchHandler() {
      const params = {}
      if (this.form.suppliesr && this.form.suppliesr.trim().length > 0) {
        params.suppliesr = this.form.suppliesr
      }
      if (this.form.anufacturer && this.form.anufacturer.trim().length > 0) {
        params.anufacturer = this.form.anufacturer
      }
      if (this.form.source && this.form.source.trim().length > 0) {
        params.source = this.form.source
      }
      if (this.form.poNo && this.form.poNo.trim().length > 0) {
        params.poNo = this.form.poNo
      }
      if (this.form.itemNo && this.form.itemNo.trim().length > 0) {
        params.itemNo = this.form.itemNo
      }
      if (this.form.hblNo && this.form.hblNo.trim().length > 0) {
        params.hblNo = this.form.hblNo
      }
      this.toQuery(params)
    },
    toQuery(params = null) {
      this.loading = getLoading()
      // EDIContainer.queryPoPackageListWithHblNo(containerInfo.containerNo, _containerValue.jobUuid, _containerValue.cargoDocUuid, params, poPageResultHandler, faultHandler);
      const item = {}
      item.containerNo = this.containerInfo.containerNo
      item.jobUuid = this.cargoDoc.jobUuid
      item.cargoDocUuid = this.cargoDoc.uuid
      if (this.goodsMode === SystemConstants.FCL_TYPE.code) {
        item.ediContainerUuid = this.containerInfo.uuid
        if (params) {
          item.suppliesr = params.suppliesr || ''
          item.poNo = params.poNo || ''
        }
        queryOrderListByContainer(item).then(res => {
          this.fcl.rowData = res.data || []
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.goodsMode === SystemConstants.LCL_TYPE.code) {
        item.cargoDocUuid = this.cargoDoc.uuid
        item.params = params
        queryPoPackageListWithHblNo(item).then(res => {
          const result = res.data
          this.lcl.rowData = result.dataList || []
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.goodsMode === SystemConstants.CONSOLE_TYPE.code) {
        // console 模式
        item.ediContainerUuid = this.containerInfo.uuid
        if (params) {
          item.suppliesr = params.suppliesr || ''
          item.poNo = params.poNo || ''
        }
        queryOrderListByConsoleContainer(item).then(res => {
          this.console.rowData = res.data || []
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 获取选中行
    getSelections(tips = true) {
      const rows = this.lcl.gridApi.getSelectedRows()
      if (rows.length === 0 && tips) {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
      const selectPackages = []
      if (rows.length > 0) {
        for (const selectable of rows) {
          if (selectable.hblNo !== this.cargoDoc.hblNbr2) {
            const poPackage = {}
            poPackage.PO_PACKAGE_UUID = selectable.poPackageUuid
            poPackage.CARGO_DOC_UUID = this.cargoDoc.uuid
            poPackage.CONTAINER_UUID = this.containerInfo.uuid
            poPackage.HBL_NO = selectable.hblNo
            selectPackages.push(poPackage)
          }
        }
      }
      return selectPackages
    },
    // 整箱选择PO订单
    chooseHandler() {
      if (this.goodsMode === SystemConstants.FCL_TYPE.code) {
        const rows = this.fcl.gridApi.getSelectedRows()
        if (rows.length === 0) {
          throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
        }
        this.loading = getLoading()
        batchModifyEdiContainerPoInfo({ ediContainerUuid: this.containerInfo.uuid, poInfoUuid: rows[0].poInfoUuid, dataType: SystemConstants.FCL_TYPE.code }).then(res => {
          this.$message.success(this.$t('Message.ImportSuccessful1'))
          this.$emit('reloadTable')
          this.innerVisible = false
        }).finally(() => {
          this.loading.close()
        })
      } else if (this.goodsMode === SystemConstants.CONSOLE_TYPE.code) {
        const rows = this.console.gridApi.getSelectedRows()
        if (rows.length === 0) {
          throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
        }
        const poUuids = []
        for (const row of rows) {
          poUuids.push(row.uuid)
        }
        this.loading = getLoading()
        batchModifyEdiContainerPoInfo({ ediContainerUuid: this.containerInfo.uuid, poUuids: poUuids, dataType: SystemConstants.CONSOLE_TYPE.code }).then(res => {
          this.$message.success(this.$t('Message.ImportSuccessful1'))
          this.$emit('reloadTable')
          this.innerVisible = false
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 拼箱选择包装
    chooseLclHandler() {
      const selUsages = this.getSelections(false)
      if (selUsages && selUsages.length > 0) {
        // EDIContainer.batchAddEdiContainerPackage(selUsages, addGoodsResultHandler, faultHandler);
        this.loading = getLoading()
        batchAddEdiContainerPackage({ infos: selUsages }).then(res => {
          this.$message.success(this.$t('Message.ImportSuccessful1'))
          this.$emit('reloadTable')
          this.innerVisible = false
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.$message.warning(this.$t('SeaExport.importGoodsTips'))
      }
    },
    onFclGridReady(params) {
      this.fcl.gridApi = params.api
    },
    onLclGridReady(params) {
      this.lcl.gridApi = params.api
    },
    onConsoleGridReady(params) {
      this.console.gridApi = params.api
    }
  }
}
</script>

<style lang="scss" scoped>
.triggers{
  justify-content: space-between !important;
  .calculation{
    padding: 0 20px !important;
    span{
      margin-left: 5px;
    }
  }
}
</style>

